export default __webpack_public_path__ + "05eaa1ef8fbc79793c226d389e35c507.png";